import React, { useContext, useEffect, useState } from 'react';
import styles from './ProductsSubcategory.module.scss';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import 'swiper/css';
import ProductsCarousel from '../Products/ProductsCarousel';
import { ModalProvider } from '../Modal/modalContext';
import ProductButton from '../ProductModal/ProductButton';
import { DataContext } from '../../views/pages/Root';
import { addCustomPathToLink, mergeArrays } from '../../functions';

const ProductsSubcategory = ({ api }) => {
  const data = useContext(DataContext);
  const [animation, setAnimation] = useState();

  const productsList = mergeArrays(api?.attributes?.products, api?.attributes?.productsBorder);

  useEffect((_) => {
    if (!!api.attributes.animationName) {
      setAnimation(!!data?.animations2?.length && data.animations2.find((prop) => prop.name == api.attributes.animationName));
    }
  }, []);
  return (
    <section id={api?.id} className={`wrapper ${styles.sectionProductSub} ${!!api.attributes.image ? '' : styles.no_image}`}>
      {(!!api?.attributes?.image ||
        !!api?.attributes?.animationName ||
        !!api?.attributes?.title ||
        !!api?.attributes?.section_title ||
        !!api.attributes?.descriptionWithoutImage ||
        !!api.attributes?.description ||
        (!!api.attributes?.btnLink && api.attributes?.btnText)) && (
        <div className={styles.topContainer}>
          {!!api.attributes?.image && (
            <div className={styles.imageContainer} data-aos="fade-up" data-aos-duration="500" data-aos-once="false" data-aos-easing="ease-in-out">
              <figure className={styles.imageWrapper}>
                <img className={styles.image} src={addCustomPathToLink(api.attributes.image.src, true)} alt={api.attributes.image.alt} />
              </figure>
              {!!api.attributes?.image?.imagePointsCoordinates &&
                api.attributes.image.imagePointsCoordinates.map((point) => (
                  <ModalProvider key={point.id}>
                    <ProductButton point={point} />
                  </ModalProvider>
                ))}
              {!!api.attributes?.image?.imagePointsYellow &&
                api.attributes.image.imagePointsYellow.map((point) => (
                  <ModalProvider key={point.id}>
                    <ProductButton point={point} />
                  </ModalProvider>
                ))}
            </div>
          )}
          <div className={styles.contextContainer} data-aos="fade-left" data-aos-duration="500" data-aos-easing="ease-in-out" data-aos-once="false">
            {!!api.attributes.animationName && (
              <figure className={styles.backgroundContainer}>
                {!!animation && <Lottie autoplay="true" animationData={animation?.value} loop={true} className={styles.animationOnImage}></Lottie>}
              </figure>
            )}
            <div className={styles.mainTextContainer}>
              {(!!api?.attributes?.title || !!api?.attributes?.section_title) && (
                <h2 className={styles.title}>{!!api?.attributes?.title ? api.attributes.title : api.attributes.section_title}</h2>
              )}
              {!!api.attributes?.descriptionWithoutImage && !!api.attributes.image && (
                <p className={styles.descWithoutImage}>{api.attributes?.descriptionWithoutImage}</p>
              )}
              {!!api.attributes?.description && <p className={styles.desc}>{api.attributes?.description}</p>}
              {!!api.attributes?.descriptionWithoutImage && !api.attributes.image && (
                <p className={styles.desc}>{api.attributes?.descriptionWithoutImage}</p>
              )}
            </div>
            <div className={styles.descContainer} data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out" data-aos-once="false">
              {!!api.attributes.btnLink && !!api.attributes.btnText && (
                <a className={styles.btnShowMore} target="_blank" href={api.attributes.btnLink}>
                  {api.attributes.btnText}
                </a>
              )}
            </div>
          </div>
        </div>
      )}
      {!!productsList && <ProductsCarousel productsList={productsList} type={'productSubcategory'} />}
    </section>
  );
};

export default ProductsSubcategory;
